import knowledgeDlg from './src/main.js'
export default knowledgeDlg



// WEBPACK FOOTER //
// ./src/components/knowledgeDlg/index.js